import { css } from '@styles/theme'

export const questionPrintStyles = {
	container: css({
		pageBreakInside: 'avoid',
	}),

	containerQuestion: css({
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'baseline',
		padding: '16px',
		gap: '16px',
		width: '100%',
		height: '100%',
		borderRadius: '12px',
	}),

	containerDesc: css({
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		padding: '0px',
		gap: '32px',

		h6: {
			_font: 'normal',
			fontWeight: 500,
			fontSize: ' 16px',
			lineHeight: '21px',
			letterSpacing: '0.05em',
			color: '#6BBBDC',
		},

		p: {
			_font: 'normal',
			fontWeight: 400,
			fontSize: ' 16px',
			lineHeight: '21px',
			letterSpacing: '0.05em',
			color: '#141414',
		},
	}),

	numberContainer: css({
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',

		minWidth: '26px',
		height: '30px',

		background: '$neutral20',
		border: '1px solid $neutral50',
		borderRadius: '4px',

		_font: 'normal',
		fontWeight: 500,
		fontSize: ' 14px',
		lineHeight: '21px',
		letterSpacing: '0.05em',
		color: '$neutral150',
	}),

	containerAnswer: css({
		display: 'flex',
		flexDirection: 'column',
		gap: '10px',
		margin: '10px 0px',
		paddingLeft: '58px',

		h3: {
			_font: 'normal',
			fontWeight: 400,
			fontSize: ' 16px',
			lineHeight: '21px',
			letterSpacing: '0.05em',
			color: '#141414',
		},
	}),

	feedbackContainer: css({
		display: 'flex',
		flexDirection: 'column',
		padding: '32px',
		gap: '9px',
		margin: '20px 0px',

		width: '100%',
		height: '100%',

		background: 'rgba(107, 187, 220, 0.08)',
		borderRadius: '12px',

		h5: {
			_font: 'normal',
			fontWeight: 500,
			fontSize: '16px',
			lineHeight: '21px',
			letterSpacing: '0.05em',
		},

		p: {
			_font: 'normal',
			fontWeight: 400,
			fontSize: '16px',
			lineHeight: '21px',
			letterSpacing: '0.05em',
			color: '$neutral120',
		},
	}),
}
